import "bootstrap/dist/css/bootstrap.min.css"
import React from "react"
import Layout from "./src/components/layout"
import "./src/styles/App.css"

export const wrapPageElement = ({ element, props }) => {
  return <Layout {...props}>{element}</Layout>
}
